import axios from 'axios'
import { API_URL } from '../Shared/apiEndPointUrl'

/* Handle the generate questions list service */ 
export const generateQuestionsService = (requestBody) => {
  return axios.post(`${API_URL.generateQuestions}`, requestBody)
}
